import z from 'zod';
import { zodRedirectSchema, zodStringOptionSchema } from '../../Validators';

export const validateAddAllocatioinFirstStepSchema = z.object({
  CPI: zodStringOptionSchema,
  requiredSample: zodStringOptionSchema,
  suppliers: z
    .array(
      z.object({
        globalRedirects: z.boolean().default(false),
      }),
    )
    .min(1, { message: 'At least one supplier is required' }),
});

export const validateAddSurveAllocationSchema = z.object({
  CPI: zodStringOptionSchema,
  requiredSample: zodStringOptionSchema,
  suppliers: z
    .array(
      z.object({
        redirects: zodRedirectSchema,
        label: zodStringOptionSchema.shape.label,
        value: zodStringOptionSchema.shape.value,
        globalRedirects: z.boolean(),
      }),
    )
    .min(1, { message: 'At least one supplier is required' }),
});

export const validateEditSurveyAllocationSchema = z.object({
  CPI: zodStringOptionSchema,
  requiredSample: zodStringOptionSchema,
  globalRedirects: z.boolean(),
  redirects: zodRedirectSchema.optional(),
});
